import { Button, SCLogo } from '@servicecompressionllc/sc-design-system';
import { useLoginPageLogic } from './useLoginPageLogic.js';

export const LoginPage = () => {
  const { showCard, signIn } = useLoginPageLogic();

  if (!showCard)
    return (
      <div
        role="status"
        className="min-h-screen flex items-center justify-center bg-surface text-sm text-ink-muted"
      >
        Signing you in…
      </div>
    );

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface px-4">
      <div className="w-full max-w-sm bg-surface-elevated rounded-lg border border-outline p-8 text-center">
        <div className="flex justify-center mb-6">
          <span className="text-primary">
            <SCLogo className="h-16 w-16" />
          </span>
        </div>
        <h1 className="text-2xl font-bold text-ink mb-2">SC Platform Admin</h1>
        <p className="text-ink-muted mb-6">
          Sign in with your Service Compression account to manage your tenant.
        </p>
        <Button onClick={signIn} className="w-full">
          Sign in with Microsoft
        </Button>
      </div>
    </div>
  );
};
